(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9195],{

/***/ 67801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(1391);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 86118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BlogListing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(68037);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(98616);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(53978);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/components/BlogListing/utils.js

var onItemClick = function(slugUrl) {
    if (!checkRenderEnv/* IS_SERVER */.W6) {
        var link = window.location.href.split("");
        var ifLastCharSlash = link[link.length - 1] === "/";
        window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/").concat(slugUrl);
    }
};

;// CONCATENATED MODULE: ./src/components/BlogListing/BlogCard.js



function BlogCard1(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "users_list",
        className: "blog-card-main-wrapper tw-cursor-pointer",
        onClick: function() {
            return onItemClick(props === null || props === void 0 ? void 0 : props.slug_url);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: props === null || props === void 0 ? void 0 : props.page_id,
            className: "list-card list-card-blog w-100-l flex flex-column relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-column items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "blog-image flex items-center justify-center relative",
                        children: [
                            (props === null || props === void 0 ? void 0 : props.featured_image) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                id: (props === null || props === void 0 ? void 0 : props.page_id) + "_" + "image",
                                src: props === null || props === void 0 ? void 0 : props.featured_image,
                                className: "card-image"
                            }) : null,
                            (props === null || props === void 0 ? void 0 : props.updated_date) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "date-box f5 flex flex-column justify-center items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "f3 fw6",
                                        children: props === null || props === void 0 ? void 0 : props.updated_date
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "month-selected",
                                        children: props === null || props === void 0 ? void 0 : props.updated_date
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-100 card-body",
                        children: [
                            (props === null || props === void 0 ? void 0 : props.page_name) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: (props === null || props === void 0 ? void 0 : props.page_id) + "_" + "blog-heading",
                                className: "mb2 f4 fw7",
                                children: props === null || props === void 0 ? void 0 : props.page_name
                            }) : null,
                            (props === null || props === void 0 ? void 0 : props.excerpt) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: (props === null || props === void 0 ? void 0 : props.page_id) + "_" + "blog-body",
                                className: "pb4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "f5 o-50 card-body__text",
                                        children: [
                                            props === null || props === void 0 ? void 0 : props.excerpt.replace(/<[^>]*>/g, "").slice(0, 150),
                                            "...",
                                            " "
                                        ]
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "fw6 f5 underline-hover pointer",
                                        children: "Read Full Blog"
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        }, props === null || props === void 0 ? void 0 : props.page_id)
    });
}

;// CONCATENATED MODULE: ./src/containers/BlogListing/index.js









function BlogListing(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8 = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            catalogCategories: state.catalogReducer.categories
        };
    }), storeInfo = ref8.storeInfo, catalogCategories = ref8.catalogCategories;
    var ref9 = (0,react.useState)({
        pages: {}
    }), state = ref9[0], setState = ref9[1];
    (0,react.useEffect)(function() {
        setState({
            pages: props === null || props === void 0 ? void 0 : props.pages
        });
    }, [
        props
    ]);
    var onWrapperClick = function(dataReceived) {
        if (props.onElementClick) {
            props.onElementClick((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dataReceived), {
                templateId: props.templateId
            }));
        }
    };
    var onViewMoreBtnClick = function() {
        var ref;
        if ((ref = state.section) === null || ref === void 0 ? void 0 : ref.slug) {
            var ref1;
            var link = window.location.href.split("");
            var ifLastCharSlash = link[link.length - 1] === "/";
            window.location.href = "".concat(window.location.href).concat(ifLastCharSlash ? "" : "/").concat((ref1 = state.section) === null || ref1 === void 0 ? void 0 : ref1.slug);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, (0,_object_spread/* default */.Z)({
                    storeData: storeInfo,
                    categories: catalogCategories || []
                }, layout));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "blog_section_1",
                className: "blog-main-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "section_title",
                        className: "black section-title tc",
                        onClick: function() {
                            return onWrapperClick({
                                parentKey: "",
                                itemIndex: null,
                                keyToBeUpdated: "section_title",
                                childKeyToBeReplaced: "display_text"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "fw6 heading",
                            children: "Our Blogs"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-flex-wrap tw-justify-center",
                        children: props === null || props === void 0 ? void 0 : (ref3 = props.blogList) === null || ref3 === void 0 ? void 0 : ref3.map(function(blogData) {
                            /*#__PURE__*/ return (0,react.createElement)(BlogCard1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, blogData), {
                                key: blogData === null || blogData === void 0 ? void 0 : blogData.page_id
                            }));
                        })
                    }),
                    ((ref4 = state.pages) === null || ref4 === void 0 ? void 0 : ref4.length) > 10 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "flex justify-center items-center view-more-btn--container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: onViewMoreBtnClick,
                            className: "view-more-btn",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "w-100 tc",
                                children: "View More"
                            })
                        })
                    }) : null
                ]
            }),
            (ref5 = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.components) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Footer) === null || ref7 === void 0 ? void 0 : ref7.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, (0,_object_spread/* default */.Z)({
                    storeData: storeInfo,
                    categories: catalogCategories || []
                }, layout));
            })
        ]
    });
}


/***/ }),

/***/ 1391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _containers_BlogListing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86118);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81605);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68037);







var AdditionalPageContainer = function(props) {
    var ref, ref1, ref2, ref3;
    var advCustomSeo = props.advCustomSeoDetails;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        store: storeInfo,
        title: "Blogs - ".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.name),
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.store_info) === null || ref1 === void 0 ? void 0 : ref1.logo_image,
        metaDescription: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : advCustomSeo.description) || "Now order online from my whatsapp store & pay using 150+ UPI Apps",
        OGTitle: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : (ref2 = advCustomSeo.og_title) === null || ref2 === void 0 ? void 0 : ref2.value) || null,
        OGDescription: (advCustomSeo === null || advCustomSeo === void 0 ? void 0 : advCustomSeo.og_description) || null,
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref3 = storeInfo.store_info) === null || ref3 === void 0 ? void 0 : ref3.logo_image,
        isCustomDomain: props.isCustomDomain
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_BlogListing__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (AdditionalPageContainer);


/***/ }),

/***/ 98616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5580,1605,9774,2888,179], function() { return __webpack_exec__(67801); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);